import React, { useEffect } from 'react';
import ViewReport from '../ViewReport';
import {
  Wrapper,
  HeaderWrapper,
  Span1,
  Span2,
  QueryPara,
  FlexWrapper,
  ChannelsText,
  TwitterText,
  StyledContainer,
  QueryPara2,
  TabHeading,
  Icon,
  DownloadWrapper,
  DateWrapper,
  CreateTopic,
  FlexForLogoDiv,
  InstagramImgDiv,
  H3TitleForInsta,
  PTitleforInsta,
} from '../ViewReport.styled';
import Overview from './ReportDownload/Overview';
import { useDispatch, useSelector } from 'react-redux';
import { convertToTimeZone, formatDate } from '../../../utils';
import {
  AmazonIconSmall,
  FacebookLogoSmall,
  FlipkartIcon,
  FlipkartLogo,
  Instagram,
  InstagramLogo,
  NewsLogo,
  X_icon,
  YouTubeRedIcon,
} from '../../../Common/SvgIcon/CommonSvgIcons';
import { fetchCreatedTopic } from '../../../store/redux/slices/topicSlice';
import Sentiments from './ReportDownload/Sentiments';
import ClusterAnalysisTab from './ReportDownload/ClusterAnalysisTab';
import Insights from './ReportDownload/Insights';
import OverViewTab from './ReportDownload/Chatter/OverViewTab';
import SentimentsTab from './ReportDownload/Chatter/SentimentsTab';
import InsightsTab from './ReportDownload/Chatter/InsightsTab';
import ClusterAnalysis from './ReportDownload/Chatter/ClusterAnalysisTab';
import OverviewTabInsta from './ReportDownload/OverviewTabInsta';
import ReviewsTab from '../../ActiveTopic/ReviewsTab/ReviewsTab';
import CommentsTab from '../../ChatterTracker/MainComponent/ChatterPreview/CommentsTab/CommentsTab';
import CustomAnalysisTab from './ReportDownload/CustomAnalysisTab';
import OverviewNews from './ReportDownload/OverviewNews';
import { Verified } from '@mui/icons-material';
import ReachComponent from './ReportDownload/Reach';

const DownloadFile = ({
  data,
  job_id,
  email_id,
  created_at,
  is_topic = true,
  AnalysisFilter,
  formatValue = 'dd-MM-yyyy',
  personalDetailsData,
}) => {
  function convertDateTime(inputDateTime) {
    let dtObject = new Date(inputDateTime);
    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    let formattedDate =
      monthNames[dtObject.getMonth()] +
      ' ' +
      dtObject.getDate() +
      ' on ' +
      (dtObject.getHours() % 12 || 12) +
      ':' +
      (dtObject.getMinutes() < 10 ? '0' : '') +
      dtObject.getMinutes() +
      ' ' +
      (dtObject.getHours() >= 12 ? 'PM' : 'AM');

    return formattedDate;
  }

  let { formattedDate, formattedTime } = convertToTimeZone(
    created_at,
    personalDetailsData?.app_preference?.time_zone,
    personalDetailsData?.app_preference?.time_format === '12 Hour'
      ? true
      : false,
    personalDetailsData?.app_preference?.date_format
  );
  const dispatch = useDispatch();

  let { getAllReportData } = useSelector((state) => state.sentinelHub) || [];
  let channel = getAllReportData[0]?.report?.channel || '';
  let { topicPreviewData } = useSelector((state) => state.topicBuilder) || {};
  const { createdTopicData } = useSelector((state) => state.topicBuilder);

  let fetchedData = getAllReportData[0]?.report?.data;

  const overView_tab = fetchedData?.overview_tab || {};
  const reach_tab = fetchedData?.reach_tab || {};

  const sentiments_tab = fetchedData?.sentiments_tab || {};
  const insights_tab = fetchedData?.insights_tab || {};
  const clusterAnalysis_tab = fetchedData?.cluster_analysis_tab || {};

  const startDate = getAllReportData[0]?.report?.start_date || '2024/01/01';
  const endDate = getAllReportData[0]?.report?.end_date || '2024/01/02';
  const selectedTopic = createdTopicData.find(
    (topic) => topic.job_id === job_id
  );
  function formatNumber(num) {
    if (num >= 1_000_000_000) {
      // Billion
      return (num / 1_000_000_000).toFixed(1) + 'B';
    } else if (num >= 1_000_000) {
      // Million
      return (num / 1_000_000).toFixed(1) + 'M';
    } else if (num >= 1000) {
      // Thousand
      return (num / 1000).toFixed(1) + 'k';
    } else {
      return num; // Return the number as is if it's less than 1000
    }
  }

  return (
    <Wrapper style={{ marginTop: '30px' }}>
      <HeaderWrapper>
        <Span1>
          {getAllReportData.length > 0 &&
            (getAllReportData[0]?.report?.topic_title ||
              (getAllReportData?.length > 0 &&
                getAllReportData[0]?.report?.title))}
        </Span1>
        <Span2>
          {getAllReportData.length > 0 &&
            getAllReportData[0]?.report?.description}
        </Span2>
        <StyledContainer>
          <ChannelsText>Channels:</ChannelsText>
          <TwitterText showYotube={getAllReportData[0]?.report?.channel == 'youtube' ? true : false}>
            <Icon>
              {getAllReportData.length > 0 ? (
                getAllReportData[0]?.report?.is_topic == true ? (
                  getAllReportData[0]?.report?.channel == 'instagram' ? (
                    InstagramLogo
                  ) : getAllReportData[0]?.report?.channel == 'facebook' ? (
                    FacebookLogoSmall
                  ) : getAllReportData[0]?.report?.channel == 'news' ? (
                    NewsLogo
                  ) : getAllReportData[0]?.report?.channel == 'youtube' ? (
                    YouTubeRedIcon
                  ) :
                    (
                      X_icon
                    )
                ) : getAllReportData[0]?.report?.channel == 'amazon' ? (
                  AmazonIconSmall
                ) : (
                  FlipkartLogo
                )
              ) : (
                <></>
              )}
            </Icon>{' '}
            &nbsp;{' '}
            <span style={{ marginBottom: '5px' }}>
              {getAllReportData.length > 0 &&
                getAllReportData[0]?.report?.channel?.replace(/{|}/g, '')}
            </span>
          </TwitterText>
        </StyledContainer>
        {getAllReportData.length > 0 &&
          getAllReportData[0]?.report?.is_topic ? (
          getAllReportData[0]?.report?.channel == 'instagram' ?
            getAllReportData[0]?.report?.search_type == 'user' ? (
              <div>
                <FlexForLogoDiv>
                  {/* <InstagramImgDiv>
                                        <img src={getAllReportData[0]?.report?.profile_pic_url || ''} alt='drc' style={{ width: '80px', height: '80px', borderRadius: '50%' }} />

                                    </InstagramImgDiv> */}
                  <div>
                    <H3TitleForInsta>
                      {getAllReportData[0]?.report?.user_name ||
                        decodeURIComponent(
                          getAllReportData[0]?.report?.user_name || ''
                        )}
                      <span
                        style={{
                          color: 'rgb(25, 118, 210)',
                          height: '23px',
                          marginLeft: '8px',
                        }}
                      >
                        {/*  */}
                        {getAllReportData[0]?.report?.search_type == 'user' &&
                          getAllReportData[0]?.report?.verified == true && (
                            <Verified />
                          )}
                      </span>
                    </H3TitleForInsta>
                    <PTitleforInsta>
                      {getAllReportData[0]?.report?.full_name || ''}
                    </PTitleforInsta>
                    <PTitleforInsta>
                      {getAllReportData[0]?.report?.search_type == 'user'
                        ? `${formatNumber(
                          getAllReportData[0]?.report?.engagement
                        )} followers`
                        : getAllReportData[0]?.report?.search_type == 'hashtag'
                          ? `${formatNumber(
                            getAllReportData[0]?.report?.engagement
                          )} posts`
                          : ''}
                    </PTitleforInsta>
                  </div>
                </FlexForLogoDiv>
              </div>
            ) :
              getAllReportData[0]?.report?.channel == 'instagram' &&
              getAllReportData[0]?.report?.search_type == 'hashtag' && (
                <div>
                  <FlexForLogoDiv>
                    <InstagramImgDiv>
                      <div
                        style={{
                          width: '70px',
                          borderRadius: '50%',
                          fontSize: '50px',
                          textAlign: 'center',
                        }}
                      >
                        #
                      </div>
                      {/* } */}
                    </InstagramImgDiv>
                    <div>
                      <H3TitleForInsta>
                        {(getAllReportData[0]?.report?.user_name &&
                          `#${getAllReportData[0]?.report?.user_name}`) ||
                          ''}
                      </H3TitleForInsta>
                      <PTitleforInsta>
                        {`${formatNumber(
                          getAllReportData[0]?.report?.engagement
                        )} posts` || ''}
                      </PTitleforInsta>
                    </div>
                  </FlexForLogoDiv>
                </div>
              )

            :

            getAllReportData[0]?.report?.channel == 'youtube' && getAllReportData[0]?.report?.youtube_search_type == 'page' ?
              (
                <div>
                  <FlexForLogoDiv>
                    {/* <InstagramImgDiv>
                                      <img src={getAllReportData[0]?.report?.profile_pic_url || ''} alt='drc' style={{ width: '80px', height: '80px', borderRadius: '50%' }} />

                                  </InstagramImgDiv> */}
                    <div>
                      <H3TitleForInsta>
                        {getAllReportData[0]?.report?.user_name ||
                          decodeURIComponent(
                            getAllReportData[0]?.report?.user_name || ''
                          )}
                        <span
                          style={{
                            color: 'rgb(25, 118, 210)',
                            height: '23px',
                            marginLeft: '8px',
                          }}
                        >
                          {/*  */}
                          {getAllReportData[0]?.report?.search_type == 'user' &&
                            getAllReportData[0]?.report?.verified == true && (
                              <Verified />
                            )}
                        </span>
                      </H3TitleForInsta>
                      <PTitleforInsta>
                        {getAllReportData[0]?.report?.full_name || ''}
                      </PTitleforInsta>
                      <PTitleforInsta>
                        {getAllReportData[0]?.report?.search_type == 'user'
                          ? `${formatNumber(
                            getAllReportData[0]?.report?.engagement
                          )} followers`
                          : getAllReportData[0]?.report?.search_type == 'hashtag'
                            ? `${formatNumber(
                              getAllReportData[0]?.report?.engagement
                            )} posts`
                            : ''}
                      </PTitleforInsta>
                    </div>
                  </FlexForLogoDiv>
                </div>
              )
              :

              (
                <QueryPara>
                  <b>Query Used:&nbsp;</b>{' '}
                  {getAllReportData.length > 0 &&
                    getAllReportData[0]?.report?.keywords_string}
                  <br />
                </QueryPara>
              )

        ) : (
          // <a style={{ color: 'rgb(53, 60, 247)', wordBreak: 'break-all' }} href={(getAllReportData[0]?.report?.hyperlink)}>{getAllReportData.length > 0 && getAllReportData[0]?.report?.hyperlink}</a>
          <a
            style={{ color: 'rgb(45, 137, 85)', wordBreak: 'break-all' }}
            href={getAllReportData[0]?.report?.hyperlink}
            target='_blank'
            rel='noopener noreferrer'
          >
            {getAllReportData?.length > 0 &&
              getAllReportData[0]?.report?.hyperlink}
          </a>
        )}
        {/* <br /> lang: en since: 2023-01-01 until: 2023-05-18 geocode: 20.5937,78.9629,2000 km */}
      </HeaderWrapper>
      <DownloadWrapper>
        <div className='created_at'>
          {is_topic ? 'Report ' : 'Chatter Report '}
          Created at
          {/* {convertDateTime(created_at)} */}
          <span style={{ marginLeft: '5px' }}>
            {formattedDate && formattedDate} {formattedTime && formattedTime}
          </span>
        </div>
      </DownloadWrapper>
      {AnalysisFilter?.Overviews?.value && is_topic ? (
        getAllReportData[0]?.report?.channel === 'news' ? (
          <OverviewNews
            overview_tab={overView_tab}
            startDate={getAllReportData[0]?.report?.start_date}
            filteredStartDate={startDate}
            filteredEndDate={endDate}
            endDate={getAllReportData[0]?.report?.end_date}
            formatValue={formatValue}
            child={AnalysisFilter?.Overviews?.child}
          />
        ) : getAllReportData[0]?.report?.channel == 'instagram' ? (
          <OverviewTabInsta
            overview_tab={overView_tab}
            startDate={getAllReportData[0]?.report?.start_date}
            filteredStartDate={startDate}
            filteredEndDate={endDate}
            endDate={getAllReportData[0]?.report?.end_date}
            child={AnalysisFilter?.Overviews?.child}
            hideDropdown={true}
            formatValue={formatValue}
            // filterOption={filterOption}
            // filteredData={filteredData?.report?.data?.overview_tab}
            // resetFlag={resetFlag}
            // view={view}
          />
        ) : (
          <Overview
            channel={getAllReportData?.[0]?.report?.channel}
            overview_tab={overView_tab}
            startDate={startDate}
            endDate={endDate}
            child={AnalysisFilter?.Overviews?.child}
            hideDropdown={true}
            formatValue={formatValue}
          />
        )
      ) : AnalysisFilter?.Overviews?.value ? (
        <OverViewTab
          plan={'BrandAstraPro'}
          selectedReport={getAllReportData[0]?.report}
          child={AnalysisFilter?.Overviews?.child}
          hideDropdown={true}
          formatValue={formatValue}
          startDate={startDate}
          endDate={endDate}
        />
      ) : (
        <></>
      )}
      <div>
        {AnalysisFilter?.Reach?.value && is_topic && (
          <ReachComponent
            xyz={reach_tab}
            child={AnalysisFilter?.Reach?.child}
            hideDropdown={true}
            is_news={
              getAllReportData[0]?.report?.channel === 'news' ? true : false
            }
            formatValue={formatValue}
            startDate={startDate}
            endDate={endDate}
          />
        )}
      </div>
      {/* ,pageBreakAfter: 'always' */}
      {/* className="pdf-page"  style={{ pageBreakBefore: 'always', pageBreakInside: 'avoid' }} */}
      <div>
        {AnalysisFilter?.Sentiments?.value && is_topic ? (
          <Sentiments
            sentiments_tab={getAllReportData[0]?.report}
            child={AnalysisFilter?.Sentiments?.child}
            hideDropdown={true}
            is_news={
              getAllReportData[0]?.report?.channel === 'news' ? true : false
            }
            formatValue={formatValue}
            startDate={startDate}
            endDate={endDate}
          />
        ) : AnalysisFilter?.Sentiments?.value ? (
          <SentimentsTab
            plan={'BrandAstraPro'}
            hideDropdown={true}
            selectedReport={getAllReportData[0]?.report}
            child={AnalysisFilter?.Sentiments?.child}
            formatValue={formatValue}
            startDate={startDate}
            endDate={endDate}
          />
        ) : (
          <></>
        )}
      </div>
      <div className='pdf-page'>
        {AnalysisFilter?.Insights?.value && is_topic ? (
          <Insights
            insights_data={insights_tab}
            child={AnalysisFilter?.Insights?.child}
            hideDropdown={true}
            formatValue={formatValue}
            startDate={startDate}
            endDate={endDate}
            channel={channel}
          />
        ) : AnalysisFilter?.Insights?.value ? (
          <InsightsTab
            // review_liked
            plan={'BrandAstraPro'}
            hideDropdown={true}
            selectedReport={getAllReportData[0]?.report}
            child={AnalysisFilter?.Insights?.child}
            channel={channel}
            formatValue={formatValue}
            startDate={startDate}
            endDate={endDate}
          />
        ) : (
          <></>
        )}
      </div>
      {AnalysisFilter?.Cluster_Analysis?.value && is_topic ? (
        <ClusterAnalysisTab
          cluster_analysis={clusterAnalysis_tab}
          formatValue={formatValue}
          startDate={startDate}
          endDate={endDate}
          child={AnalysisFilter?.Cluster_Analysis?.child}
        />
      ) : AnalysisFilter?.Cluster_Analysis?.value ? (
        <ClusterAnalysisTab
          cluster_analysis={clusterAnalysis_tab}
          formatValue={formatValue}
          startDate={startDate}
          endDate={endDate}
          child={AnalysisFilter?.Cluster_Analysis?.child}
        />
      ) : (
        // <ClusterAnalysis
        //     plan={"BrandAstraPro"}
        //     child={AnalysisFilter?.Cluster_Analysis?.child}
        //     // selectedReport={getAllReportData[0]?.report}
        //     selectedReport={getAllReportData[0]?.report?.data?.cluster_analysis_tab}
        // />
        <></>
      )}
      {/* <div className='pdf-page'>
        {AnalysisFilter?.Custom_Analysis?.value ? (
          <CustomAnalysisTab
            infoText='CustomAnalysisTab'
            AnalysisFilter={AnalysisFilter?.Custom_Analysis?.localVal}
            job_id={job_id}
            preview_uuid={topicPreviewData?.preview_uuid}
          />
        ) : (
          <></>
        )}
      </div> */}

      {/* {AnalysisFilter?.Reviews?.value && is_topic ?
                <ReviewsTab
                    download={true}
                    startDate={getAllReportData[0]?.report?.start_date}
                    endDate={getAllReportData[0]?.report?.end_date}
                    // preview_uuid={topicPreviewData?.preview_uuid}
                    job_id={data?.job_id}
                    email_id={getAllReportData[0]?.email_id}
                    channel={
                        getAllReportData[0]?.report?.channel
                    }
                />
                :
                AnalysisFilter?.Reviews?.value ?
                <CommentsTab

                    download={true}

                    job_id={data?.job_id}
                    email_id={getAllReportData[0]?.email_id}
                    // job_id={job_id}
                    channelName={
                        getAllReportData[0]?.report?.channel
                    }
                    startDate={getAllReportData[0]?.report?.start_date}
                    endDate={getAllReportData[0]?.report?.end_date}
                />
            } */}
    </Wrapper>
  );
};

export default DownloadFile;
